const model = {
    name: 'Swatch',
    properties: {
        fields: { type: 'array' },
        group_by: {},
        max: {}, // TODO: integer <int64> [ 1 .. 10 ]
    },
};
export default model;
